import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const submitLead = async (payload) => {
  if (!BACKEND_URL) throw new Error("Booking service unavailable");
  const res = await axios.post(`${BACKEND_URL}/api/leads`, payload);
  return res?.data ?? {};
};

export const errorMessage = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Please check the highlighted fields — phone and email must be valid.";
  return "Something went wrong. Please call (647) 985-8007 and we'll book you directly.";
};

export const SCOPE_KEY = "amora_scope";
export const readScope = () => {
  try { return JSON.parse(sessionStorage.getItem(SCOPE_KEY) || "null"); } catch { return null; }
};
export const saveScope = (s) => {
  try { sessionStorage.setItem(SCOPE_KEY, JSON.stringify(s)); } catch { /* storage unavailable */ }
};
